/* eslint-disable */
import React, { useState } from 'react';
import { ActionRow } from './EventRow';

const MappingStatsTable = (props) => {
    const [expandedRows, setRows] = useState([])

    const handleRowClick = (rowId) => {
        const currentExpandedRows = expandedRows;
        const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);
        const newExpandedRows = isRowCurrentlyExpanded
            ? currentExpandedRows.filter(id => id !== rowId)
            : currentExpandedRows.concat(rowId);

        setRows(newExpandedRows)
    }

    const hrefBuilder = (subdomain, path) => {
        const domainSplit = document.location.host.split('.');
        domainSplit[0] = subdomain;
        return location.protocol + '//' + domainSplit.join('.') + path;
    };

    const buildRow = (data) => {
        let fduRows = [];

        if (props.data) {
            const dateSubmitted = data.submitted_at ? new Date(data.submitted_at).toLocaleDateString('en-US') : null
            const dateCreated = new Date(data.created_at).toLocaleDateString('en-US')
            const hasFDRs = data.rows_changed.length > 0;
            const clickCallback = () => handleRowClick(data.id);
            let mapLinkPath = `/mapping_approvals/new?id=${data.id}`
            let mapLink = hrefBuilder(data.company.subdomain, mapLinkPath)
            let filename = data.filename && data.filename.length > 30 ? data.filename.slice(0, 30) + "..." : data.filename;

            fduRows.push(
                <tr key={data.id} onClick={clickCallback}>
                    <td className='kfi-text-left visits-far-left-column'>{dateSubmitted}</td>
                    <td className='kfi-text-left visits-far-left-column'>{dateCreated}</td>
                    <td className='kfi-text-left'><a href={mapLink}>{data.company.name}</a></td>
                    <td className='kfi-text-left'>{filename}</td>
                    <td className='kfi-text-left'>{data.status}</td>
                    <td className='kfi-text-left'>{`${Math.round(data.map_accuracy * 100)}%`}</td>
                    <td className='kfi-text-left'>{`${data.rows_changed.length} / ${data.total_row_count}`}</td>
                    <td className='kfi-text-left'>{data.who_mapped && data.who_mapped[0].name}</td>
                    <td className='kfi-text-left'>{data.who_generated_reports && data.who_generated_reports[0].name}</td>
                </tr>
            )
            if (hasFDRs && expandedRows.includes(data.id)) {
                fduRows.push(
                    <FduRows data={data} />
                );
            }
        }

        return (
            <>
                {fduRows}
            </>
        );
    }

    const rows = [];

    Object.values(props.data).forEach(d => rows.push(buildRow(d)));

    const renderUserVisitsTableHeader = () => {
        const headerStyle = {
            'paddingRight': '8px'
        }
        return (
            <thead>
                <tr>
                    <th style={headerStyle}>Mapped At</th>
                    <th style={headerStyle}>Created At</th>
                    <th style={headerStyle}>Company</th>
                    <th style={headerStyle}>File</th>
                    <th style={headerStyle}>Status</th>
                    <th style={headerStyle}>Accuracy</th>
                    <th style={headerStyle}>Rows Changed</th>
                    <th style={headerStyle}>Who Mapped</th>
                    <th style={headerStyle}>Who Generated Reports</th>
                </tr>
            </thead>
        )
    }


    return (
        <div>
            <table className='report-table'>
                {renderUserVisitsTableHeader()}
                <tbody>
                    {rows}
                </tbody>
            </table>
        </div>
    )
};


const FduRows = (props) => {
    let actions = []
    let whoMapped = props.data.who_mapped
    let whoGeneratedReports = props.data.who_generated_reports

    if (whoMapped) {
        let mapActions = whoMapped.map(a => {
            a['row_data'] = props.data.rows_changed.filter(r => a.row_ids.includes(r.id))
            return a
        })
        actions = [...actions, ...mapActions]
    }

    if (whoGeneratedReports) {
        actions = [...actions, ...whoGeneratedReports]
    }

    let sortedActions = actions.sort((a, b) => new Date(b['date']) - new Date(a['date']));

    return (
        <>
            {sortedActions.map((action, id) =>
                <ActionRow action={action} fdu_id={props.data.id} id={id} key={`action-${props.data.id}-${id}`} />
            )}
        </>
    )
}


export default MappingStatsTable;